import Loader from 'components/Loader';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { taxonomyType } from 'utils/constants';
import { titleCaseIfExists } from 'utils/helper';

const CategoriesSearch = ({ onChange, initialValues = [], allIngredients = [], formik }) => {
  const [categories, setCategories] = useState(initialValues || []);

  const [taxonomyList, setTaxonomyList] = useState([]);

  const [expandedTypes, setExpandedTypes] = useState({});

  const toggleExpand = (slug) => {
    setExpandedTypes((prev) => ({
      ...prev,
      [slug]: !prev[slug],
    }));
  };

  useEffect(() => {
    if (!isEmpty(initialValues)) {
      setCategories(initialValues);
    }
  }, [initialValues]);

  const uniqueIngredients = Array.from(
    new Map(
      allIngredients?.filter((e) => !isEmpty(e?.group))?.map((e) => [e.group, { label: e.group, value: e.id }])
    ).values()
  );

  const updateStateAndNotify = (updatedData) => {
    setCategories(updatedData);
    onChange(updatedData);
  };

  const [gettaxonomyListRequestDefault, { loading }] = useRequest({
    url: `/common/admin/taxonomy/search`,
    method: 'POST',
    onSuccess: (data) => {
      setTaxonomyList(data?.results);
    },
  });

  useEffect(() => {
    gettaxonomyListRequestDefault({
      body: {
        page: 1,
        size: 100000,
        sortBy: 'id',
        sortOrder: 1,
        language: 'en',
        types: [
          taxonomyType.NUTRITION_MEAL_TYPE,
          taxonomyType.NUTRITION_CUISINE,
          taxonomyType.NUTRITION_DIETARY_PREFERENCE,
          taxonomyType.NUTRITION_FOOD_ITEM_TYPE,
          // taxonomyType.NUTRITION_MAIN_INGREDIENT,
          taxonomyType.NUTRITION_COOKING_METHOD,
          taxonomyType.NUTRITION_OCCASION,
          taxonomyType.NUTRITION_SPECIAL_FEATURE,
          taxonomyType.NUTRITION_OTHER_TAGS,
        ],
      },
    });
  }, []);

  const recipeTypes = [
    {
      title: 'Meal Type',
      slug: taxonomyType.NUTRITION_MEAL_TYPE,
    },
    {
      title: 'Cuisine',
      slug: taxonomyType.NUTRITION_CUISINE,
    },
    {
      title: 'Dietary Preference',
      slug: taxonomyType.NUTRITION_DIETARY_PREFERENCE,
    },
    {
      title: 'Food Item Type',
      slug: taxonomyType.NUTRITION_FOOD_ITEM_TYPE,
    },
    {
      title: 'Cooking Method',
      slug: taxonomyType.NUTRITION_COOKING_METHOD,
    },
    {
      title: 'Occasion',
      slug: taxonomyType.NUTRITION_OCCASION,
    },
    {
      title: 'Special Feature',
      slug: taxonomyType.NUTRITION_SPECIAL_FEATURE,
    },
    {
      title: 'Other Tags',
      slug: taxonomyType.NUTRITION_OTHER_TAGS,
    },
  ];

  const handleSelectChange = (res) => {
    if (!categories?.some((item) => item?.id === res?.id)) {
      const updatedData = [...categories, { name: res.name, id: res.id, slug: res?.slug, type: res?.type }];
      updateStateAndNotify(updatedData);
    } else {
      const updatedData = categories.filter((item) => item?.id !== res?.id);
      updateStateAndNotify(updatedData);
    }
  };

  return (
    <>
      <Loader isActive={loading} />
      <div className="mt-4">
        <Row>
          {/* <Col className="mb-4" md={4}>
            <Card className="bg-light h-100">
              <CardBody>
                <h5 className="border bg-white p-2 mb-3 text-center w-100 rounded-2">Main Ingredient</h5>
                <ul className="ps-0">
                  {uniqueIngredients?.map((item, index) => {
                    const isSelected = !isEmpty(categories.find((e) => e?.id === item?.id));
                    return (
                      <li className="mb-1" style={{ listStyle: 'none' }} key={`main_${index}`}>
                        <label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => handleSelectChange(item)}
                          />
                          <span className="ps-1">
                            {titleCaseIfExists(item?.label?.replaceAll('_', ' ')?.replaceAll('-', ' '))}
                          </span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </CardBody>
            </Card>
          </Col> */}

          {recipeTypes?.map((type, index) => {
            const itemsList = taxonomyList
              ?.sort((a, b) => a?.name?.localeCompare(b?.name))
              ?.filter((e) => e?.type === type?.slug);

            const expanded = expandedTypes[type?.slug] || false;
            const visibleItems = expanded ? itemsList : itemsList?.slice(0, 10);

            return (
              !isEmpty(itemsList) && (
                <Col className="mb-4" md={4} key={`type_${index}`}>
                  <Card className="bg-light">
                    <CardBody>
                      <h5 className="border bg-white p-2 mb-3 text-center w-100 rounded-2">{type?.title}</h5>
                      <ul className="ps-0">
                        {visibleItems?.map((item, index) => (
                          <li className="mb-1" style={{ listStyle: 'none' }} key={`item_${index}`}>
                            <label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={!isEmpty(categories.find((e) => e?.id === item?.id))}
                                onChange={(e) => handleSelectChange(item)}
                              />
                              <span className="ps-1">
                                {titleCaseIfExists(item.name?.replaceAll('_', ' ')?.replaceAll('-', ' '))}
                              </span>
                            </label>
                          </li>
                        ))}
                      </ul>

                      {itemsList?.length > 10 && (
                        <button type="button" className="btn btn-link p-0" onClick={() => toggleExpand(type?.slug)}>
                          {expanded ? (
                            <>
                              See Less <i className="fas fa-chevron-up ms-1" />
                            </>
                          ) : (
                            <>
                              See More <i className="fas fa-chevron-down ms-1" />
                            </>
                          )}
                        </button>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              )
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default CategoriesSearch;
